<app-table *ngIf="driverFailureData" [rowsSelectable]="true" 
  [columns]="driverFailureColumns" [dataMap]="driverFailureDataMap" [rawData]="driverFailureData"
  [showSelectionSummaryTop]="false" [showSelectionSummaryBottom]="true" [showTableAverages]="true" [showTableTotals]="true">
</app-table>